const convertHtmlToString = (html: string) => {
  const htmlTagRegex = /<[^>]*>/g;
  return html.replace(htmlTagRegex, '');
};
export default convertHtmlToString;
